import {
  Directive,
  ElementRef,
  OnChanges,
  input
} from '@angular/core';

export interface CssVarsObj {
    [key: string]: string;
}

@Directive({ selector: '[appCssVars]' })
export class CssVarsDirective implements OnChanges {

    readonly appCssVars = input<CssVarsObj>(undefined);

    constructor(private el: ElementRef) {
    }

    ngOnChanges() {
        const appCssVars = this.appCssVars();
        if (!appCssVars) {
            return;
        }
        Object.keys(appCssVars).forEach(key => {
            const appCssVarsValue = this.appCssVars();
            if (!!appCssVarsValue[key]) {
                this.el.nativeElement.style.setProperty(key, appCssVarsValue[key]);
            }
        });
    }
}
